import api from '../api'
import convertLang from '../../../utils/convertLang'
import { fallback } from '~/services/fetch/modules/fallback'

const qs = require('qs')

const apiRoute = '/legals'

export const getPageBySlug = async (locale, slug) => {
  const query = qs.stringify(
    {
      locale: convertLang.convertLang(locale),
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: {
        page: {
          populate: ['hero', 'hero.image_mobile', 'hero.image_tablet', 'hero.image_desktop', 'items', 'banner'],
        },
      },
    },
    {
      encodeValuesOnly: true,
    }
  )
  try {
    const ROUTE = `${apiRoute}?${query}`

    const response = await api.get(`${ROUTE}`)

    if (!response.data.data[0]['page']) {
      throw new Error(`Unexpected result after fetching: ${ROUTE}`)
    }

    return response.data.data[0]['page']
  } catch {
    const RESULT = fallback({ slug, locale })

    return RESULT
  }
}

export default {
  getPageBySlug,
}
